<div class="product-card" [ngClass]="layout" (click)="onNavigate()">
  <div class="product-image" [style.background-image]="'url(' + imageUrl + ')'"></div>

  <div class="product-info">
    <p class="info-title">
      {{ title }}
    </p>

    @if (layout === 'horizontal' && description) {
      <p class="info-description">{{ productData.bars[0].name }}</p>
      <p class="info-description">{{ description }}</p>
    }

    <div class="price-wrapper">
      <p class="price-current">
        R$ {{
          (currentPrice && currentPrice < price) ? currentPrice : price
          | number: '1.2-2'
        }}
      </p>

      @if (currentPrice && currentPrice < price) {
        <p class="price-original">R$ {{ price | number: '1.2-2' }}</p>
      }
    </div>
  </div>

<!--
  <div *ngIf="productData.tags.length > 0" style="display:flex">
  @for (item of productData.tags; track item) {
  <span class="circle-image"  [ngStyle]="{'background-color': item.color}">
    <img src="{{item.icon}}" alt="Imagem Circular" />
  </span>
  }
  
  @if (layout === 'horizontal') {
    <button class="btn-favorite" (click)="setFavorite(); $event.stopPropagation()">
      <mat-icon [svgIcon]="myFavorites.includes(productData.documentId)  ? 'favorite' : 'favorite-border'"></mat-icon>
    </button>
  }
</div>
-->
    <button class="btn-favorite" (click)="setFavorite(); $event.stopPropagation()">
      <mat-icon [svgIcon]="myFavorites.includes(productData.documentId)  ? 'favorite' : 'favorite-border'"></mat-icon>
    </button>
</div>